module.exports = __webpack_public_path__ + "f92afa570faf3c1c5d0002f45534515d.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/large-leaf-linden.jpg
 ** module id = 451
 ** module chunks = 0
 **/